
import { convertDateToDdMmYyyy, openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import EnteteBonEtFacture from '@/views/en-tete-bon-facture';
import EnteteA5 from '@/views/entete-a5';
import OrdonnanceMedicaleModal from '@/views/consultations/en-cours/ordonnance-medicale-modal';
import { cca_config } from '../../../../../CCA_ENV_CONF/env';

import $ from 'jquery';

export default {
    name: 'ordonnance-medicale',

    components: {
        EnteteBonEtFacture,
        EnteteA5, OrdonnanceMedicaleModal
    },
    props: {
        consultation: Object,
        section_name: String,
        evolution_id: Number,
        evolution_toggler: Number,
        current_consultation_evolution: Number,
        is_start: Number
    },

    data () {
        return {
            vm_state: open_menu_state,
            date_resultat: '',           //  Date d'enregistrement du résultat
            prescripton_length: 0,
            format_ordonnace: 'a5',       //  A5 (si prescriptions <= 6 ) ou A4 ( si prescription > 6)
            width_ordonnance: '559px',
            font_size: 'font-12',
            filename: '',
            
            loading: true.valueOf,

            to_delete: [],
            del_loading: false,
            del_disable: false,
            is_confirm: false,

            ord_is_loading: true,
            ord_is_empty: false,

            is_printing: false,
            pdl_papier_entete: cca_config.PDL_PAPIER_ENTETE,

            selected_ordonnance: {},
            selected_prescription: {},
            modal_toggler: 0,

            data_to_be_deleted: {},
            ordonnance_to_print: {},

            info_patient: {},
            info_caissier: {}
        }
    },

    watch: {
        evolution_toggler() {
            this.date_resultat = convertDateToDdMmYyyy.convertDate(new Date());  // Temporaire. NB : A remplacer par la date du resultat
        
            const t = new Date()
            this.filename = 'Ordonnance_'+this.patient.nom+' '+this.patient.prenoms+'_'+t.getTime()

            this.refreshOrdonnance()

            const ts = this;
            $(document).bind("click", function(e) {
                const $clicked = $(e.target);
                if (!$clicked.parents().hasClass("drp-container")) {
                    if (ts.vm_state != 0) {
                        ts.openMenu(ts.vm_state, 'drp-menu', 'animate-zoomIn', 'animate-zoomOut')
                    }
                }
            });

            this.userInfoSetter()
            this.$store.commit("SET_ORDONNANCE_TO_PRINT", {})
            this.$store.commit("SET_CAN_PRINT_ORDONNANCE", false)
        }
    },

    computed: {
        consultation_ordonnances() {
            return this.$store.getters["consultation_ordonnances"];
        },

        patient(){
            return this.$store.getters['patient'];
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        evolution_id_initiale() {
            return this.$store.getters['evolution_id_initiale']
        }
    },

    mounted () {
        
    },

    methods: {
        userInfoSetter() {
            this.info_patient = {
                nom_patient: this.patient.nom+' '+this.patient.prenoms,
                sexe: (this.patient.sexe_id == 1)?'H':(this.patient.sexe_id == 2)?'F':'',
                telephone: this.patient.telephone_mobile,
                num_dossier: this.patient.code,
                age: this.patient.age
            }

            this.info_caissier = {
                nom_caissier: this.userCredentials.name,
                titre: this.userCredentials.titre
            }
        },

        /**
         * Open Menu Dropdown
         */
        async openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        async closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        addToOrdonnance(ordonnance_id) {
            this.modal_toggler = (this.modal_toggler === 0)?1:0
            this.selected_ordonnance = {
                ordonnance_id: ordonnance_id,
                prescription: []
            }
        },

        editOrdonnance(ordonnance, evolution_id) {
            this.modal_toggler = (this.modal_toggler === 0)?1:0
            this.selected_ordonnance = {
                ordonnance_id: ordonnance.ordonnance_id,
                prescription: ordonnance.prescriptions,
                evolution_id: evolution_id
            }
        },

        editPrescription(ordonnance_id, prescription, evolution_id) {
            this.selected_prescription = prescription
            this.selected_prescription.ordonnance_id = ordonnance_id
            this.selected_prescription.user_id = this.userCredentials.id
            this.selected_prescription.evolution_id = evolution_id,
            this.selected_prescription.consultation_id = this.consultation.id
        },

        refreshOrdonnance() {
            this.ord_is_loading = true
            const data = {
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id_initiale,
                enCours: true,
            }
            this.$store.dispatch('getConsultationOrdonnance', data).then(() => {
                if (this.consultation_ordonnances.length > 0) {
                    this.ord_is_empty = false
                } else {
                    this.ord_is_empty = true 
                }

                this.ord_is_loading = false
            })
        },

        removePrecription(ordonnance_id, prescription, evolution_id) {
            this.data_to_be_deleted = {}
            this.data_to_be_deleted = prescription
            this.data_to_be_deleted.ordonnance_id = ordonnance_id
            this.data_to_be_deleted.user_id = this.userCredentials.id
            this.data_to_be_deleted.evolution_id = evolution_id
            this.data_to_be_deleted.consultation_id = this.consultation.id
        },

        setOrdonnanceToRemove(ordonnance, evolution_id) {
            this.data_to_be_deleted = {}
            this.data_to_be_deleted.ordonnance_id = ordonnance.ordonnance_id
            this.data_to_be_deleted.libelle = ordonnance.reference
            this.data_to_be_deleted.user_id = this.userCredentials.id
            this.data_to_be_deleted.evolution_id = evolution_id
            this.data_to_be_deleted.consultation_id = this.consultation.id
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        printOrdonnance(ordonnance) {
            this.$store.commit("SET_ORDONNANCE_TO_PRINT", ordonnance)
            this.$store.commit("SET_CAN_PRINT_ORDONNANCE", true)
        },
    }
}


